export default {
    intro: `มีสำนวนที่ผิดหรือฟังดูไม่เป็นธรรมชาติปนอยู่<br />ลองหาส่วนที่ไม่เป็นธรรมชาติแล้วแก้ให้ถูกต้องดูสิ!`,
    select: 'เลือกเลย',
    fill: 'ลองแก้ส่วนที่ไม่เป็นธรรมชาติให้ดูเป็นธรรมชาติสิ!',
    wrong: 'อุ๊ย ผิดแล้ว ลองอีกครั้งนะ',
    find: 'ลองหาแล้วกดที่ส่วนที่ไม่เป็นธรรมชาติดูสิ',
    findCount: ' จุดที่ยังเหลืออยู่',
    table: {
        question: 'โจทย์',
        answerRate: 'อัตราการตอบถูก',
        emptyMessage: 'ไม่มีเนื้อหา',
    },
};
